// This Privileges list created from the vault team Excel
export const PRIVILEGES = {
  VIEW_MESSAGING_AVAILABILITY_INFO: '1740',
  SKILL_CHATS: '9',
  VIEW_AGENT_LIST: '1574',
  VIEW_ALL_CHATS: '10',
  VIEW_MESSAGING_SURVEYS: '1754',
  VIEW_CAMPAIGN_MODULE: '1500',
  VIEW_USERS_MODULE: '1501',
  SET_MANUAL_SLA: '1741',
  SEND_FILES_FROM_CUSTOM_WIDGET: '1777',
  UPDATE_CONSUMER_PROFILE_VIA_API: '1750',
  VIEW_SECURE_FORMS: '1558',
  VIEW_HISTORY_SECURE_FORMS: '1571',
  GENERATE_SECURE_FORM_TOKEN: '1728',
  TRANSFER_TO_OFFLINE_AGENT: '1768',
  TRANSFER_TO_AWAY_AGENT: '1767',
  TRANSFER_TO_ONLINE_AND_BACK_SOON_AGENT: '1766',
  JOIN_CONVERSATION_PRIVILEGE: '13',
  HAS_AGENT_OR_AGENT_MANAGER_PROFILE: '1561',
  VIEW_AGENT_WORKSPACE: '1786',
  TAKEOVER: '1731',
  MESSAGING_HISTORY_PRIVILEGE: '1713',
  VIEW_ACTIVE_CONNECTIONS: '1734',
  ANSWERING_SERVICE_AGENT: '1764',
  SEND_FILES_FROM_LOCAL_SYSTEM: '1771',
  FAAS_INVOKE: '1772',
  VIEW_SMART_SUGGESTIONS: '1793',
  VIEW_AUTOCOMPLETE: '1794',
  PROVIDE_FEEDBACK_ON_SUGGESTION_OR_AUTOCOMPLETE: '1795',
  VIEW_AGENT_SURVEY: '1798',
  SUBMIT_AGENT_SURVEY: '1799',
};

export const SESSION_SETTINGS = {
  AUTO_ACCEPT: 'messaging.routing.autoaccept',
  LANGUAGE: 'le.general.language',
  RECENTLY_CLOSED_CONVERSATIONS_DAYS: 'le.agent.recentlyClosedConversationDays',
  HOUR_FORMAT: 'le.agent.hourFormat',
  DISABLE_EMOJIS: 'le.agent.chatInput.disableIconsForMessaging',
  DISABLE_IFRAME_SANDBOX: 'disable.custom.widget.iframe.sandbox',
  DEFAULT_SUPPORTED_LANGUAGE: 'le.site.defaultSupportedLanguage',
  SUPPORTED_LANGUAGES: 'le.site.supportedLanguages',
  BLOCK_CONSUMER_NAME: 'le.agent.block.visitor.name',
  SUPPORT_UNAUTH_SDES: 'le.agent.messaging.sdes',
  SHOW_NEW_AGENT_WORKSPACE: 'le.agent.messaging.showEnhancedAgentWorkspace',
  ACD_MANUAL_SLA_AUTO_FOCUS_CONVERSATION:
    'messaging.ACD.manual.autoFocusConversation',
  FILE_SHARING_IMAGE_PREVIEW_SIZE: 'messaging.agent.photo.size',
  FILE_SHARING_IS_ENABLED_FOR_AGENT: 'messaging.agent.file.sharing.enabled',
  FILE_SHARING_IS_ENABLED: 'messaging.file.sharing.enabled',
  AUDIO_SHARING_IS_ENABLED: 'messaging.audio.sharing.enabled',
  NEW_AGENT_WORKSPACE_LPA: 'le.agent.messaging.newAgentWorkspaceForLPA',
  ALLOW_MICROPHONE_CAMERA: 'le.agent.widgetSdk.allowMicrophoneCamera',
  PREDEFINED_CONTENT_SHOW_TITLE_ONLY: 'le.agent.messaging.pdc.show.title.only',
  SHOW_AUTH_INDICATOR_FOR_CONNECTOR: 'le.newAgentWorkspace.showAuthIndicatorForConnectors',
  IDLE_TIME: 'le.agent.messaging.conversationIdleTime.minutes',
  SMART_SUGGESTIONS_API_URLS: 'le.suggestions',
  ACCOUNT_INFO: 'le.site.accountInfo',
  SMART_CAPACITY_DEFAULT: 'messaging.smart.capacity.fresh.agent.pending.time.sec',
  SMART_CAPACITY_PER_SKILL: 'messaging.smart.capacity.per.skill.definition',
  DEACTIVATE_SHORTCUTS: 'le.general.deactivateShortcuts',
  SHOW_CONVERSATION_SOURCE_IN_LIST: 'le.newAgentWorkspace.showConversationSourceInList',
  ALERT_ON_PASTE: 'le.agent.alertOnPaste',
  DISABLED_NON_RESPONSE_STATE: 'messaging.connection.nonresponsivestate.disabled',
};

export const FEATURES = {
  ASYNC_MESSAGING: 'Common.Async_Messaging',
  AGENT_WORKSPACE_FEATURE: 'Messaging.New_agent_workspace',
  ENFORCE_NEW_AGENT_WORKSPACE: 'LEUI.Enforce_New_Agent_Workspace',
  BLOCK_NEW_AGENT_WORKSPACE: 'LEUI.Block_New_Agent_Workspace',
  VIEW_MESSAGING_SECURE_FORM: 'LEUI.Messaging_Secure_Form',
  VIEW_SECURE_FORM_HISTORY: 'Reports.EngagementHistory_PCI_Data_Display',
  GENERATE_SECURE_FORM_TOKEN: 'Reports.GenerateSecureFormToken',
  TRANSFER_TO_AGENT: 'Messaging.Transfer_To_Agent',
  TAKEOVER: 'Common.Takeover_Conversation',
  MESSAGING_SURVEY: 'Common.Messaging_Survey',
  AGENT_GROUPS: 'Common.AgentGroups',
  CAN_SHARE_ADDITIONAL_FILE_TYPES: 'Messaging.Agent_File_Sharing_v2',
  FAAS: 'FaaS.FaaS',
  CONTACT_CENTER: 'Common.Messaging_Cross_Account_Contact_Center',
  AGENT_SET_CONSUMER_PROFILE: 'Messaging.AgentSetConsumerProfile',
  SOCIAL_CONNECT: 'SocialConnect.Enabled',
  CAN_USE_SMART_SUGGESTIONS: 'Messaging.Smart_Suggestions',
  CAN_SEND_HYPERLINKS: 'Messaging.Agent_Link_Sending',
  CONVERSATION_SUMMARY_WIDGET: 'Messaging.Conversation_Summary_Widget',
  AGENT_SURVEY: 'Messaging.Agent_Survey',
  RICH_CONTENT: 'Common.RichContent',
  SEND_PRIVATE_MESSAGE: 'Messaging.Private_Messages',
  // When this feature is on, there is no need to update agent status in UMS
  PREVENT_UPDATE_AGENT_STATUS_AT_UMS: 'Messaging.Set_Agent_State_By_Facts',
};

export const FEATURE_FLAGS = {
  SHOW_INLINE_RECOMMENDED_ACTIONS: 'showInlineRecommendedActions',
  SHOW_AGENT_SURVEY: 'showAgentSurvey',
  SEPARATED_OPEN_CLOSED_SUBSCRIPTIONS: 'separatedOpenClosedSubscriptions',
  SEND_PRIVATE_MESSAGE: 'sendPrivateMessage',
  SHOW_PAGE_NAVIGATION_WIDGET: 'showPageNavigationWidget',
};

export const ACCOUNT_VERTICAL = {
  AUTOMOTIVE: 'automotive',
};
